<div class="footer-container">
  <span class="footer">{{ 'module.layout.footer.text' | translate: { companyName: companyName, year: copyrightYear } }} v.{{ version }}</span>
  <a class="footer-link-1" (click)="goTo()">{{ 'module.layout.footer.footerLink1Text' | translate }}</a>
  <a class="footer-link-2" target="_blank" href="{{ 'module.layout.footer.footerLink2Value' | translate }}">{{
    'module.layout.footer.footerLink2Text' | translate
  }}</a>
  <a class="footer-link-3" target="_blank" href="{{ 'module.layout.footer.footerLink3Value' | translate }}">{{
    'module.layout.footer.footerLink3Text' | translate
  }}</a>
  <a class="footer-link-4" *ngIf="hasFourthFooterLink" target="_blank" href="{{ 'module.layout.footer.footerLink4Value' | translate }}">{{
    'module.layout.footer.footerLink4Text' | translate
  }}</a>
</div>
